import classNames from 'classnames'
import Icon from '../assets'

const PanelHeader = ({ title, collapsible, isOpen, togglePanel }) => (
  <div
    onClick={collapsible ? togglePanel : null}
    class={classNames({
      'panel-heading': true,
      'panel-heading--collapsible': collapsible }
    )}
  >
    {title}
    {collapsible
      ? <Icon
        icon={`${isOpen ? 'arrowDropUp' : 'arrowDropdown'}`}
        width={18}
        height={18}
      />
      : null}
  </div>
)

export default PanelHeader
